import { formatDecimal } from "../JS/Common";
import { ApiGetCall } from "../JS/Connector";

async function GetPricingDetailsPart(schoolId, setLoading, setSchoolCustomPriceParts) {
    setLoading(true);
    const result = await ApiGetCall(`/parts/school-pricing?schoolId=${schoolId}`);
    if (result == undefined || result == "") {
        alert("Something went wrong");
    } else {
        const responseRs = JSON.parse(result);
        const customPriceMap = (responseRs?.data?.parts || [])?.reduce((acc, item) => {
            acc[item.part_id] = Number(item.custom_price);
            return acc;
        }, {});
        setSchoolCustomPriceParts(prevState => ({
            ...prevState,
            schoolHalvedFlag: responseRs?.data?.school_repair_type_discount ?? 2,
            customPricingParts: customPriceMap,
            hasCustomParts: responseRs?.data?.school_custom_part_price ?? 2
        }));
    }
}

function halfPrice(price) { return formatDecimal(price / 2); }

function PriceReasonResFun(price, reason) { return { price: price, reason: reason } } // Response Function

function doSort(ToSortList, sortNode) {
    if (ToSortList) return [...ToSortList].sort((a, b) => Number(b?.[sortNode] || 0) - Number(a?.[sortNode] || 0))
}

function getBillingColor(part, customPriceMap) {
    const hasCustom = customPriceMap[part.id] !== undefined;
    return hasCustom ? 'billingOrangeText' : ''; // only custom price or none
}

function getBasePrice(item, customPriceMap, PartPriceNode, OriginalPriceNode) {
    // If price manually changed then return same price
    if (item.price_correction_reason == 1) return PriceReasonResFun(Number(item?.[PartPriceNode] || 0), 1);
    const custom = customPriceMap[item.id];
    if (custom != null) return PriceReasonResFun(Number(custom), 2);
    return PriceReasonResFun(Number(item?.[OriginalPriceNode] || 0), 6);
}

const savedBillingColorMap = {
    2: 'billingOrangeText',
    3: 'billingPurpleText',
    4: 'billingCyanText'
};

function findHighest(list, customPriceMap, toggledPartId, PartPriceNode, OriginalPriceNode, isZeroFun) {
    if (!list?.length) return null;
    if (toggledPartId) return list.find(p => p.id === toggledPartId) || null;

    // isZeroFun: excludes zero-price items (logic varies per page)
    // item.flag: excludes 'schoolColorStatus' (RepairDetails only; undefined in TicketHistory → no effect)
    const eligibleList = list.filter(item => !isZeroFun(item) && item.flag !== 'schoolColorStatus');
    if (!eligibleList.length) return null;

    // get the highest price
    return eligibleList.reduce((max, item) => {
        const price = getBasePrice(item, customPriceMap, PartPriceNode, OriginalPriceNode)?.price ?? 0;
        const maxPrice = getBasePrice(max, customPriceMap, PartPriceNode, OriginalPriceNode)?.price ?? 0;
        return price > maxPrice ? item : max;
    });
}

const PriceReasonMap = Object.freeze({
    ZeroVal: 0, // 0 -> Warranty, Rework, No Discount Flag, etc
    ManualVal: 1, // 1 -> price manually changed
    CustomVal: 2, // 2 -> custom price only
    HalvedVal: 3, // 3 -> halving only
    CustomHalvedVal: 4, // 4 -> custom price + halving
    HighestVal: 5, // 5 -> highest price
    NoChangesVal: 6, // 6 -> Add New or No Changes
    HandleApplyVal: 7 // 7 -> Exception Case Handle Apply All
});

const handleOnFocusChange = (priceOnFocusRef, currentValue) => {
    priceOnFocusRef.current = currentValue;
}

export { GetPricingDetailsPart, halfPrice, PriceReasonResFun, doSort, getBillingColor, getBasePrice, savedBillingColorMap, findHighest, PriceReasonMap, handleOnFocusChange }